// src/pages/search.js
import React, { useEffect } from "react";
import { graphql } from "gatsby";
import { useI18next, Link } from 'gatsby-plugin-react-i18next';
import { translateHead } from "../helpers/helpers";
import { useMixpanel } from 'gatsby-plugin-mixpanel'

import Layout from "../components/layout/layout";
import SearchBar from "../components/search/search-bar"
import Seo from "../components/seo"

const NotFoundPage = ({ pageContext, location, data }) => {
  const { language } = pageContext;
  const { navigate } = useI18next();
  const mixpanel = useMixpanel()

  const handleSearch = (query) => {
    navigate(`/search?query=${encodeURIComponent(query)}`);
  };

  useEffect(() => {
    mixpanel.track('page_view', {
      source: '404_page',
      language: language
    });
  }, [mixpanel, language]);

  return (
    <Layout categories={data.allMongodbTestCategories.nodes}>
      <section>
        <SearchBar onSearch={handleSearch} />
        <h1 className="display-4">404 - Emoji Not Found!</h1>
        <p className="lead">Oh no! It seems like the emoji you're looking for is missing in action.</p>
        <p>Maybe it's off on a cosmic adventure. In the meantime, why not explore some other emojis?</p>
        <p>
          <Link to="/">Go back to EmojiGalaxy's Home</Link>
        </p>
      </section>
    </Layout >
  );
};

export const Head = ({ pageContext, data }) => {
  const { language } = pageContext;
  const pageTitle = translateHead("404.title", language, data.locales);
  const metaDescription = translateHead("404.description", language, data.locales);

  return (
    <Seo title={pageTitle} description={metaDescription} />
  )
}

export default NotFoundPage;

export const query = graphql`
query($language: String!) {
  allMongodbTestCategories {
    nodes {
      emoji
      id
      name {
        en
        es
        fr
      }
      url
      mongodb_id
      hidden
    }
  }
  locales: allLocale(filter: {language: {eq: $language}}) {
    edges {
      node {
        ns
        data
        language
      }
    }
  }
}
`;